import { render, staticRenderFns } from "./GradientBGSphere.vue?vue&type=template&id=ffe0a056&"
import script from "./GradientBGSphere.vue?vue&type=script&lang=js&"
export * from "./GradientBGSphere.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports